<div id="logout">
    <p-message severity="info" i18n>You have been logged out, redirecting to login...</p-message>
</div>
